// components/widgets/primitives/serif-headline.js
// ═══════════════════════════════════════════════════════════
// SERIF HEADLINE + SUMMARY — Literata typography for the
// primary statement of a widget. Headline is h2; summary is
// italic Literata sized down.
// ═══════════════════════════════════════════════════════════

export function SerifHeadline({ children, level = 2, className = '' }) {
  if (!children) return null;
  const Tag = `h${level}`;
  return <Tag className={`ws-prim-headline ${className}`}>{children}</Tag>;
}

export function SerifSummary({ children, className = '' }) {
  if (!children) return null;
  return <p className={`ws-prim-summary ${className}`}>{children}</p>;
}

// Default export = Headline (most common consumer pattern)
export default SerifHeadline;
